import { defineMessages } from 'react-intl';

export const EmailSentMessages = defineMessages({
  sent: {
    description: 'filterOptions.customerEmailSent',
    defaultMessage: 'Sent',
    id: 'vU/Q1r',
  },
  notSent: {
    description: 'filterOptions.customerEmailNotSent',
    defaultMessage: 'Not Sent',
    id: 'Bw/lDB',
  },
  error: {
    description: 'filterOptions.customerEmailError',
    defaultMessage: 'Failed',
    id: 'NylRjc',
  },
});

export const LabelMessages = defineMessages({
  printed: {
    description: 'filterOptions.labelPrinted',
    defaultMessage: 'Printed',
    id: 'CI9dYY',
  },
  notPrinted: {
    description: 'filterOptions.labelNotPrinted',
    defaultMessage: 'Not Printed',
    id: 'Iea+MZ',
  },
});
